import styled from 'styled-components'

import { BREAKPOINTS, Flex, media } from '@web-apps/ui-shared'

export const StyledLoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  flex: 1;

  padding-block-start: 48px;
  padding-block-end: 64px;
`

export const StyledSplashContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-inline: 24px;

  max-width: 396px;
  flex: 1;

  ${media.from(
    BREAKPOINTS.md,
    `
      flex: unset;
      justify-content: unset;
    `
  )}
`

export const StyledSplashSlideContainer = styled(Flex)`
  position: relative;
  height: 80%;
  max-height: 598px;

  svg {
    width: 100%;
    height: 100%;
  }
`

export const StyledSplashSlideGradient = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.2) 30%,
    rgba(255, 255, 255, 1) 85%
  );
`

export const StyledSplashTextContainer = styled.div`
  position: absolute;
  /* needed to center with phone case */
  left: -16px;
  right: 0;
  bottom: 0;

  text-align: center;
`

export const StyledProgressBarContainer = styled.div`
  width: 100%;

  ${media.from(
    BREAKPOINTS.md,
    `
      margin-block-start: 80px;
    `
  )}
`
